/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppAnalyticsPeriodDataSchema = z.object({
	startDate: z.string(),
	endDate: z.string(),
})

export type WhatsAppAnalyticsPeriodDataSchema = z.infer<typeof whatsAppAnalyticsPeriodDataSchema>
